module.exports = __webpack_public_path__ + "img/artalk-img.43d73c84.png";